'use strict';
import { Component, Inject, Input, Output, EventEmitter, OnInit} from 'ng-metadata/core';
var angular:angular.IAngularStatic =  require('angular');

@Component({
    "selector": "prm-easybib",
    templateUrl: 'components/search/actions/easyBibAction/easybib.html'
})


export class PrmEasybib implements OnInit{
    @Output() closeTabsEvent= new EventEmitter<void>();

    constructor() {
    }

    ngOnInit() {
        this.closeTabsEvent.emit(null);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/actions/easyBibAction/easybib.directive.ts